import { NgModule } from '@angular/core';
import { EchartComponent } from './echart/echart.component';
import { CommonModule } from '@angular/common';
import { LayoutModule } from 'app/layout/layout.module';
import { CoreCommonModule } from '@core/common.module';
import { PageHeaderComponent } from './page-header/page-header.component';
import { ToastContainerComponent } from './toasts/toast-container/toast-container.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TickersTableComponent } from './tickers-table/tickers-table.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { Select2Module } from "ng-select2-component";
import { NewsColumnComponent } from './news-column/news-column.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { SocketIoModule, SocketIoConfig } from 'ngx-socket-io';
import { environment } from 'environments/environment';
import { TickerNavComponent } from './ticker-nav/ticker-nav.component';
import { TickerStatusComponent } from './ticker-status/ticker-status.component';
import { PriceChangeComponent } from './price-change/price-change.component';
import { PriceChangeItemComponent } from './price-change-item/price-change-item.component';
import { MacroSummaryComponent } from './macro-summary/macro-summary.component';
import { MacroTickerComponent } from './macro-ticker/macro-ticker.component';
import { IntradayChartComponent } from './intraday-chart/intraday-chart.component';
import { MarketMapComponent } from './market-map/market-map.component';
import { TrendCardComponent } from './trend-card/trend-card.component';
import { TickerValueComponent } from './ticker-value/ticker-value.component';
import { NewsComponent } from './news/news.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { PaginatedTableComponent } from './paginated-table/paginated-table.component';
import { SubscriptionComponent } from './subscription/subscription.component';
import { RouterModule } from '@angular/router';
import { BarchartComponent } from './barchart/barchart.component';
import { CollectionSearchComponent } from './collection-search/collection-search.component';
import { WalletSearchComponent } from './wallet-search/wallet-search.component';
import { SubscribeNowComponent } from './subscribe-now/subscribe-now.component';
import { CryptoSearchComponent } from './crypto-search/crypto-search.component';
import { TickerFundamentalComponent } from './ticker-fundamental/ticker-fundamental.component';
import { EthComponent } from './eth/eth.component';
import { ExportExcelComponent } from './export-excel/export-excel.component';

const config: SocketIoConfig = { url: environment.wsUrl };

@NgModule({
  declarations: [
    EchartComponent,
    PageHeaderComponent,
    ToastContainerComponent,
    TickersTableComponent,
    NewsColumnComponent,
    TickerNavComponent,
    TickerStatusComponent,
    PriceChangeComponent,
    PriceChangeItemComponent,
    MacroSummaryComponent,
    MacroTickerComponent,
    IntradayChartComponent,
    MarketMapComponent,
    TrendCardComponent,
    TickerValueComponent,
    NewsComponent,
    PaginatedTableComponent,
    SubscriptionComponent,
    BarchartComponent,
    CollectionSearchComponent,
    WalletSearchComponent,
    SubscribeNowComponent,
    CryptoSearchComponent,
    TickerFundamentalComponent,
    EthComponent,
    ExportExcelComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    CoreCommonModule,
    NgbModule,
    NgxDatatableModule,
    NgSelectModule,
    NgxPaginationModule,
    RouterModule,
    SocketIoModule.forRoot(config)
  ],
  exports: [
    EchartComponent,
    PageHeaderComponent,
    ToastContainerComponent,
    NgbModule,
    TickersTableComponent,
    Select2Module,
    NewsColumnComponent,
    NgSelectModule,
    TickerNavComponent,
    TickerStatusComponent,
    PriceChangeComponent,
    MacroSummaryComponent,
    MacroTickerComponent,
    IntradayChartComponent,
    MarketMapComponent,
    TrendCardComponent,
    TickerValueComponent,
    NewsComponent,
    PaginatedTableComponent,
    SubscriptionComponent,
    NgxDatatableModule,
    BarchartComponent,
    CollectionSearchComponent,
    WalletSearchComponent,
    SubscribeNowComponent,
    CryptoSearchComponent,
    TickerFundamentalComponent,
    EthComponent,
    ExportExcelComponent
  ]
})
export class ComponentsModule { }
